export async function sendJobView(jobId: string) {
  try {
    await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/jobs/${jobId}/view`, {
      method: "POST",
    });
  } catch (e) {
    console.log("Could not send job view:", e);
  }
}
